/*
 * Public API Surface of iconify
 */

export * from './lib/icon.directive';
export * from './lib/icon.module';
export * from './lib/icon.interface';
export * from './lib/icon-props.interface';
